var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAccountSwitch = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.775,
    height: 20,
    viewBox: "0 0 19.775 20",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b7bec5",
    className: "a",
    d: "M14.483,8.191c2.094,0,6.292,1.052,6.292,3.146v2.247H15.382V11.337a3.781,3.781,0,0,0-1.762-3.1l.863-.045m-7.191,0c2.094,0,6.292,1.052,6.292,3.146v2.247H1V11.337C1,9.243,5.2,8.191,7.292,8.191m0-1.8a2.7,2.7,0,1,1,2.7-2.7,2.7,2.7,0,0,1-2.7,2.7m7.191,0a2.7,2.7,0,1,1,2.7-2.7,2.7,2.7,0,0,1-2.7,2.7M8.191,15.157V17.18h5.393V15.157l2.921,2.921L13.584,21V18.978H8.191V21L5.27,18.079Z",
    transform: "translate(-1 -1)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccountSwitch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/account-switch.3f13601a.svg";
export { ForwardRef as ReactComponent };